import { render, staticRenderFns } from "./class-recent.vue?vue&type=template&id=56205cbe&scoped=true"
import script from "./class-recent.vue?vue&type=script&lang=js"
export * from "./class-recent.vue?vue&type=script&lang=js"
import style0 from "./class-recent.vue?vue&type=style&index=0&id=56205cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56205cbe",
  null
  
)

export default component.exports